var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-mobile"},_vm._l((_vm.getSocialData),function(link){return _c('base-link',{key:link.link,staticClass:"social-link",attrs:{"url":link.link}},[_c('base-svg',{staticClass:"social-icon",attrs:{"name":link.icon.path}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }